import RichTextModal from '../../components/richTextModal';
function showRichText(data) {
  if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
  const params = {
    html: data.htmlContent,
    link: {
      linkTitle: data.jumpUrlTitle,
      linkSrc: data.jumpUrl,
      linkType: data.jumpType == 1 ? '_blank' : '_self',
    },
    wrapper: this.$container.get(0),
  };
  new RichTextModal(params);
}

export default {
  showRichText,
};
